module.exports = __webpack_public_path__ + "img/log-edit.0654c878.svg";